package com.routexk.quiz.ui.sections.header

import androidx.compose.runtime.Composable
import com.routexk.quiz.ui.sections.header.components.MenuItems

@Composable
internal fun NavHeaderDesktop() {
    MenuItems()
}
